import React, { useContext } from 'react'
import Context from '../../context'
import Textarea from '../Textarea'
import TableOptions from '../TableOptions'

import {
  FieldGroup
} from '../../layout/mixins'
import {
  ALARM_INSTRUCTIONS, SABOTAGE_INSTRUCTIONS, EMERGENCY_INSTRUCTIONS, FALSE_ALARM_INSTRUCTIONS, FIRE_INSTRUCTIONS
} from '../../config/alarmPrivateForm'


const PrivateAlarmInstructions = () => {
  const {
    getValue, setField
  } = useContext(Context)

  const alarmInstructions = getValue('alarm_instructions')
  const sabotageInstructions = getValue('sabotage_instructions')
  const emergencyInstructions = getValue('emergency_instructions')
  const falseAlarmInstructions = getValue('false_alarm_instructions')
  const fireInstructions = getValue('fire_instructions')

  return (
    <>
      <TableOptions
        headlines={['Inbrottslarm', 'Instruktioner', 'Val']}
        options={ALARM_INSTRUCTIONS}
        name="alarm_instructions"
        onChange={setField('alarm_instructions')}
        value={getValue('alarm_instructions')}
        required
      />
      {alarmInstructions === 'custom' ? (
        <FieldGroup>
          <Textarea
            name="alarm_instructions_custom"
            placeholder="Egen instruktion"
            onChange={setField('alarm_instructions_custom')}
            value={getValue('alarm_instructions_custom')}
            required
            instructions="OBS! Måste godkännas av Cubsec innan driftsättning."
          />
        </FieldGroup>
      ) : null}

      <TableOptions
        headlines={['Sabotagelarm', 'Instruktioner', 'Val']}
        options={SABOTAGE_INSTRUCTIONS}
        name="sabotage_instructions"
        onChange={setField('sabotage_instructions')}
        value={getValue('sabotage_instructions')}
        required
      />
      {sabotageInstructions === 'custom' ? (
        <FieldGroup>
          <Textarea
            name="sabotage_instructions_custom"
            placeholder="Egen instruktion"
            onChange={setField('sabotage_instructions_custom')}
            value={getValue('sabotage_instructions_custom')}
            required
            instructions="OBS! Måste godkännas av Cubsec innan driftsättning."
          />
        </FieldGroup>
      ) : null}

      <TableOptions
        headlines={['Nödlarm', 'Instruktioner', 'Val']}
        options={EMERGENCY_INSTRUCTIONS}
        name="emergency_instructions"
        onChange={setField('emergency_instructions')}
        value={getValue('emergency_instructions')}
        required
      />
      {emergencyInstructions === 'custom' ? (
        <FieldGroup>
          <Textarea
            name="emergency_instructions_custom"
            placeholder="Egen instruktion"
            onChange={setField('emergency_instructions_custom')}
            value={getValue('emergency_instructions_custom')}
            required
            instructions="OBS! Måste godkännas av Cubsec innan driftsättning."
          />
        </FieldGroup>
      ) : null}

      <TableOptions
        headlines={['Brandlarm', 'Instruktioner', 'Val']}
        options={FIRE_INSTRUCTIONS}
        name="fire_instructions"
        onChange={setField('fire_instructions')}
        value={getValue('fire_instructions')}
        required
      />
      {fireInstructions === 'custom' ? (
        <FieldGroup>
          <Textarea
            name="fire_instructions_custom"
            placeholder="Egen instruktion"
            onChange={setField('fire_instructions_custom')}
            value={getValue('fire_instructions_custom')}
            required
            instructions="OBS! Måste godkännas av Cubsec innan driftsättning."
          />
        </FieldGroup>
      ) : null}

      <TableOptions
        headlines={['Fellarm', 'Instruktioner', 'Val']}
        options={FALSE_ALARM_INSTRUCTIONS}
        name="false_alarm_instructions"
        onChange={setField('false_alarm_instructions')}
        value={getValue('false_alarm_instructions')}
        required
      />
      {falseAlarmInstructions === 'custom' ? (
        <FieldGroup>
          <Textarea
            name="false_alarm_instruction_custom"
            placeholder="Egen instruktion"
            onChange={setField('false_alarm_instructions_custom')}
            value={getValue('false_alarm_instructions_custom')}
            required
            instructions="OBS! Måste godkännas av Cubsec innan driftsättning."
          />
        </FieldGroup>
      ) : null}
    </>
  )
}

export default PrivateAlarmInstructions